import { useRef, useState } from "react";
import { useDgaModal } from "src/context/DgaModalContext";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { GhostButton, DeleteButton } from "src/components/Buttons";
import {
  Container,
  Breadcrumb,
  BreadcrumbTrail,
  DeleteInviteContainer,
  ModalWrapper,
  Modal,
  ModalHeader,
  ModalBody,
  ModalButtonGroup,
  CloseWrapper,
  ButtonGroup,
} from "./Header.styles";
import { ChevronRightIcon, Delete03Icon, CloseIcon } from "src/assets/icons";
import { useApplication } from "./ApplicationContext";
import { AddCircle } from "src/assets/icons";
import { APPLICATION_STATUS_KEYS } from "src/constants";
import { ApplicationOriginBadge } from "src/components/ApplicationOriginBadge";
import { shouldOpenDgaModal } from "src/utils/shouldOpenDgaModal";

export const Header = () => {
  const { application, deleteApplicationInvite } = useApplication();
  const { borrower, application_id, application_status, created_origin } =
    application;
  const borrowerName = borrower?.first_name + " " + borrower?.last_name;
  const [isOpen, setIsOpen] = useState(false);
  const { openDgaModal, openDgaModalWithLock } = useDgaModal();
  const ref = useRef(null);
  useClickOutsideModalListener(ref, () => setIsOpen(false));

  const handleClick = () => {
    deleteApplicationInvite();
    setIsOpen(false);
  };

  const showContinueEditing =
    application_id &&
    shouldOpenDgaModal(application_status ?? "", created_origin);

  return (
    <Container>
      <Breadcrumb>
        <BreadcrumbTrail>
          <span>Applications</span>
          <ChevronRightIcon />
          <span>
            {borrowerName} — {application_id}
          </span>
        </BreadcrumbTrail>
        <ApplicationOriginBadge origin={created_origin} />
      </Breadcrumb>

      <ButtonGroup>
        {application_status === APPLICATION_STATUS_KEYS.Invited && (
          <DeleteInviteContainer>
            <DeleteButton onClick={() => setIsOpen(!isOpen)}>
              Delete invite
              <Delete03Icon />
            </DeleteButton>
          </DeleteInviteContainer>
        )}

        {showContinueEditing && (
          <GhostButton
            onClick={() =>
              openDgaModalWithLock({
                id: application_id,
              })
            }
          >
            Continue editing
          </GhostButton>
        )}

        <GhostButton onClick={() => openDgaModal()}>
          New application <AddCircle />
        </GhostButton>
      </ButtonGroup>

      <ModalWrapper isOpen={isOpen}>
        <Modal ref={ref}>
          <ModalHeader>
            Delete invite
            <CloseWrapper onClick={() => setIsOpen(false)}>
              <CloseIcon />
            </CloseWrapper>
          </ModalHeader>
          <ModalBody>
            This will immediately delete the invitation and all associated data.
          </ModalBody>
          <ModalButtonGroup>
            <GhostButton onClick={() => setIsOpen(false)}>Cancel</GhostButton>
            <DeleteButton initialBg={true} onClick={handleClick}>
              Yes, delete invite
              <Delete03Icon />
            </DeleteButton>
          </ModalButtonGroup>
        </Modal>
      </ModalWrapper>
    </Container>
  );
};
